<script>
import Layout from '@layouts/default'
import appConfig from '@src/app.config'
import UserLogin from '@components/user-login'
import UserRegistration from '@components/user-registration'

export default {
  page: {
    title: 'Log in',
    meta: [{ name: 'description', content: `Log in to ${appConfig.title}` }],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/login',
      },
    ],
  },
  components: { UserLogin, Layout, UserRegistration },
  data() {
    return {
      errorMessage: this.$route.query.errorMessage,
      successMessage: this.$route.query.successMessage,
    }
  },
}
</script>

<template>
  <Layout>
    <div class="row mb-4">
      <div class="col-12 mt-4 mb-4">
        <h1>{{ $t('pages.login.h1') }}</h1>
      </div>
      <div v-if="errorMessage" class="col-12">
        <b-alert variant="danger" show dismissible>
          {{ errorMessage }}
        </b-alert>
      </div>
      <div v-if="successMessage" class="col-12">
        <b-alert variant="success" show dismissible>
          {{ successMessage }}
        </b-alert>
      </div>
      <div class="col-md-6 mbMobile">
        <div :class="$style.loginContainer" class="cardContainer cardShadow">
          <div class="cardContent">
            <h5 class="pb-2">Returning Subscriber? Sign in now.</h5>
            <p
              >Please enter your email address and password to access your
              AutoCheck account and VHR history.</p
            >
            <UserLogin />
          </div>
        </div>
      </div>
      <div class="col-md-6 mbMobile">
        <div :class="$style.loginContainer" class="cardContainer cardShadow">
          <div class="cardContent">
            <h5 class="pb-2">New to AutoCheck? Create an account.</h5>
            <UserRegistration />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <div class="cardContainer cardShadow">
          <div class="cardContent">
            <div class="row">
              <div class="col-md-3 col-12 text-center mb-4">
                <img src="images/pic_auto_deal.jpg" />
              </div>
              <div class="col-md-9 col-12">
                <h5 class="pb-2"
                  >Are you an Auto Dealer or commercial Client?</h5
                >
                <p
                  >Get more information on how AutoCheck can help you increase
                  your bottom line.</p
                >
                <a
                  href="https://www.autocheck.com/members/login.do"
                  class="d-block"
                  >Sign in to your AutoCheck account at Experian.com »</a
                >
                <a
                  href="https://www.experian.com/automotive/autocheck-business#consumer?cmpid=auto_AutoCheckConsumer_web"
                  class="d-block"
                  target="_blank"
                  >Become an AutoCheck member »</a
                >
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-3 col-12 text-center">
                <img src="images/generic-buback-protection-large.png" />
              </div>
              <div class="col-md-9 col-12">
                <h5 class="pb-2"
                  >Superior Buyback Protection included with AutoCheck</h5
                >
                <p
                  >AutoCheck Buyback Protection is available at no extra cost on
                  AutoCheck vehicle history reports if a certain title brand is
                  found after the vehicle is reported to be free of the
                  brand.</p
                >
                <p
                  ><strong
                    >There is no extra cost for you to take advantage of this
                    exclusive benefit from AutoCheck! It's simple: we miss it,
                    we buy it back.</strong
                  ></p
                >
                <BaseLink :to="{ name: 'vehicle-buyback-protection' }"
                  >Learn More »</BaseLink
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.loginContainer {
  background-color: #f2f2f2;
}
</style>
